import { defineMessages } from 'react-intl';

export default defineMessages({
	heading: {
		id: 'subpage.stress.instructorVideo.heading',
		defaultMessage: 'Meet your mindfulness instructor: Jeff Warren.',
		description: 'Heading for the stress category page instructor video',
	},
});
